import { EEstimationTargets } from '@cian/valuation-main-filters-widget';
import { ECategory } from '../../../repositories/price-estimator/entities/web/CreateSuburbanRealtyRequestSchema';

export const mapEstimationTargetToECategory: { [key: string]: ECategory } = {
  [EEstimationTargets.house]: ECategory.HouseSale,
  [EEstimationTargets.land]: ECategory.LandSale,
};
